import { builderFetch } from '../../utilities';

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.recipeType;

/**
 * Sets a new recipe type
 *
 * @param {String} recipeType The recipe type (e.g. user)
 * @return {Promise|undefined} The apiFetch promise
 */
const setRecipeType = ( recipeType ) => {
	// Check if the recipe type selected is valid
	if ( ! [ 'user', 'anonymous' ].includes( recipeType ) ) {
		return;
	}

	// Save the recipe title
	return builderFetch( {
		endpoint: 'change_post_recipe_type',
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			post_ID: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			recipe_type: recipeType
		},
		snackbar: {
			loading: strings.settingRecipeType,
			success: strings.recipeTypeSet,
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/set-recipe-type', {
				detail: {
					recipeType: recipeType
				}
			} ) );
		}

		return response;
	} );
}

export default setRecipeType;
